var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgExport = function SvgExport(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m11 11.85-1.875 1.875a.93.93 0 0 1-.713.287A1.02 1.02 0 0 1 7.7 13.7q-.275-.3-.288-.7a.92.92 0 0 1 .288-.7l3.6-3.6q.15-.15.325-.212.175-.063.375-.063t.375.063a.9.9 0 0 1 .325.212l3.6 3.6q.3.3.287.7-.012.4-.287.7-.3.3-.713.313a.93.93 0 0 1-.712-.288L13 11.85V19q0 .424-.287.712A.97.97 0 0 1 12 20a.97.97 0 0 1-.713-.288A.97.97 0 0 1 11 19zM4 8V6q0-.824.588-1.412A1.93 1.93 0 0 1 6 4h12q.824 0 1.413.588Q20 5.175 20 6v2q0 .424-.288.713A.97.97 0 0 1 19 9a.97.97 0 0 1-.712-.287A.97.97 0 0 1 18 8V6H6v2q0 .424-.287.713A.97.97 0 0 1 5 9a.97.97 0 0 1-.713-.287A.97.97 0 0 1 4 8"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgExport);
export { ForwardRef as ReactComponent };